module.exports = __webpack_public_path__ + "img/a.108b83b1.jpg";